/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Banner_ForceInputs */

const en_stage_banner_force = /** @type {(inputs: Stage_Banner_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force Transition`)
};

const pt_br2_stage_banner_force = /** @type {(inputs: Stage_Banner_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forçar Transição`)
};

/**
* | output |
* | --- |
* | "Force Transition" |
*
* @param {Stage_Banner_ForceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_banner_force = /** @type {((inputs?: Stage_Banner_ForceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Banner_ForceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_banner_force(inputs)
	return pt_br2_stage_banner_force(inputs)
});